/**
 * Fetching a view's data by reference (ADR-0117): a view block may carry only a `ref` to a system
 * call of a run (big results are not streamed); its structured result is read from the
 * orchestrator with the person's own sign-in, so only people who may see the run see the data.
 */
import type { Http } from "./http";
import { toolResultPath, type ResultRef, type ToolResultView } from "./views";

export function viewsApi(http: Http) {
  return {
    /** The structured result of one system call of a run (masked as the run's data level says). */
    /** `purpose`: why the person opened the record (ADR-0118), recorded with the read. */
    result: (ref: ResultRef, opts?: { purpose?: string }) => http.get<ToolResultView>("orchestrator", toolResultPath(ref), opts?.purpose ? { purpose: opts.purpose } : undefined),
  };
}
